// Utils
import {getBrowserCookie} from '../../../client/common/persistence/browserCookieUtils'

// Contants
import {HEPSIGLOBAL_MODAL_COUNTRY_CODES} from './hepsiglobalModalConstants'

const checkCountryCodeForHepsiglobalModal = () => {
  const countryCode = getBrowserCookie('hbCountryCode')

  if (!countryCode) {
    return false
  }

  return HEPSIGLOBAL_MODAL_COUNTRY_CODES.includes(countryCode)
}

export {checkCountryCodeForHepsiglobalModal}
